import React, { useEffect, useState } from 'react'
import { WalletStatus, getCurrentWalletConnected, mintNFT } from './wallet'

import { ButtonLight } from 'components/Button'
import styled from 'styled-components/macro'

const SUPPLY = 1000

const CenteredDiv = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  margin-top: 20px;
  margin-left: 20px;
`
interface MinterProps {
  address: string | null | undefined
}

const Minter: React.FC<MinterProps> = ({ address }: MinterProps) => {
  const [wallet, setWallet] = useState('')
  const [status, setStatus] = useState<WalletStatus | undefined>()
  const [error, setError] = useState('')
  const [mintTransaction, setMintTransaction] = useState('')
  const [initialized, setInitialized] = useState(false)
  const [mintQuantity, setMintQuantity] = useState(1)
  const [supply, setSupply] = useState(0)

  useEffect(() => {
    const initializeWallet = async () => {
      const { error, status, supply, address } = await getCurrentWalletConnected()
      setWallet(address)
      setStatus(status)
      setSupply(supply || 0)
      setError(error || '')
      if ((window as any).ethereum) {
        ;(window as any).ethereum.on('accountsChanged', (wallets: string[]) => {
          if (wallets.length > 0) {
            setWallet(wallets[0])
            setStatus(WalletStatus.WALLET_FOUND)
          } else {
            setWallet('')
            setStatus(WalletStatus.METAMASK_FOR_DUMMIES)
          }
        })
      } else {
        setStatus(WalletStatus.INSTALL_METAMASK)
      }
      setInitialized(true)
    }
    initializeWallet()
  }, [])

  const onMintPressed = async () => {
    const { status, transactionUrl } = await mintNFT(mintQuantity)
    setStatus(status)
    if (transactionUrl) {
      setMintTransaction(transactionUrl)
    }
  }

  if (!initialized) {
    return <></>
  }
  if (wallet) {
    if (supply < SUPPLY) {
      return (
        <>
          <CenteredDiv>
            <input
              size={1}
              style={{ fontSize: '24px', width: '80px', marginRight: '5px' }}
              type="number"
              name="form_felds[name]"
              id="form-field-name"
              max={10}
              min={1}
              defaultValue={1}
              onKeyUp={(e) => {
                if (parseInt(e.currentTarget.value) > 10) {
                  e.currentTarget.value = '10'
                  setMintQuantity(10)
                }
                if (parseInt(e.currentTarget.value) < 1) {
                  e.currentTarget.value = '1'
                  setMintQuantity(1)
                }
              }}
              onChange={(e) => {
                setMintQuantity(parseInt(e.currentTarget.value))
              }}
            />
            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
              <label htmlFor="form-field-name" style={{ fontSize: '24px' }}>
                Quantity
              </label>
            </div>
            <ButtonLight style={{ marginLeft: '50px', width: '100px' }} onClick={onMintPressed}>
              Mint
            </ButtonLight>
          </CenteredDiv>
          <CenteredDiv>Each NFT is 0.2 ETH. Select the quantity that you want and click Mint.</CenteredDiv>

          {!!status && status === WalletStatus.MINT_SUCCESS && (
            <CenteredDiv className="success">
              ✅{' '}
              <a
                target="_blank"
                rel="noreferrer"
                style={{
                  color: '#0cd21a',
                }}
                href={`https://opensea.io/collection/peeps-shuna-special-collab-edition-nfts`}
              >
                Click Here to go to PEEPS Shuna Opensea Page
              </a>{' '}
            </CenteredDiv>
          )}
          {!!status && status === WalletStatus.MINT_ERROR && (
            <>
              <CenteredDiv className="error">
                Check wallet to confirm transaction and verify you have enough ETH in the wallet (MetaMask may throw
                errors if you don&apos;t have enough ETH to mint with gas).
              </CenteredDiv>
              <CenteredDiv>
                <a
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: '#0cd21a',
                  }}
                  href={`https://opensea.io/collection/peeps-shuna-special-collab-edition-nfts`}
                >
                  Click to go to Opensea.
                </a>
              </CenteredDiv>
            </>
          )}
        </>
      )
    }
    return (
      <CenteredDiv>
        <h5>All PEEPS & Shuna Special Collab Edition NFTs have been minted!</h5>
      </CenteredDiv>
    )
  }

  let errorComponent
  if (!!status) {
    if (status === WalletStatus.INSTALL_METAMASK) {
      return (
        <CenteredDiv>
          <h5>
            No Wallet Provider Detected: <br></br>
            Desktop Users: Ensure a Wallet Extension is Installed.{' '}
            <a
              target="_blank"
              rel="noreferrer"
              style={{
                color: '#0cd21a',
              }}
              href={`https://opensea.io/collection/peeps-shuna-special-collab-edition-nfts`}
            >
              Click here to install Metamask
            </a>{' '}
            <br></br>
            Mobile Users: Access directly through your wallet app (Coinbase wallet or Metamask) by using the browser in
            the app.
          </h5>
        </CenteredDiv>
      )
    } else if (status === WalletStatus.METAMASK_FOR_DUMMIES) {
      errorComponent = <div className="error">Awaiting Connection.</div>
    } else if (status === WalletStatus.WALLET_ERROR) {
      errorComponent = <div className="error">Wallet Connect Error, Refresh {error}</div>
    }
  }

  return (
    <CenteredDiv>
      <h5>Please connect your wallet to mint</h5>
    </CenteredDiv>
  )
}

export default Minter
